import { ApiError } from "@secretaa/sdk";
import type { TFunction } from "i18next";

const PROJECT_ROLES = new Set(["viewer", "editor", "manager"]);
const roleLabel = (t: TFunction, role: unknown) => (typeof role === "string" && PROJECT_ROLES.has(role) ? t(`projectMembers.roles.${role}`) : t("access.roleNone"));

/**
 * Mã lỗi chuẩn ⇒ câu hiển thị (i18n). Mã chưa có bản dịch ⇒ câu chung, không lộ chi tiết kỹ thuật.
 * `details` dạng chuỗi của lỗi được đưa vào làm tham số câu (vd. `INVITATION_EMAIL_MISMATCH`: email đang đăng nhập +
 * email được mời đã che — SAA-2026-011).
 * `PERMISSION_DENIED` của data-api kèm `requiredRole` / `currentRole` (SAA-2026-012 A1.2) ⇒ câu nói rõ cần vai trò gì,
 * đang là gì và ai cấp được; policy của bảng dữ liệu (`reason: collection_policy`) có câu riêng.
 */
export function errorMessage(t: TFunction, error: unknown): string {
  if (error instanceof ApiError) {
    const d = error.details ?? {};
    if (error.code === "PERMISSION_DENIED" && d.reason === "collection_policy") return t("errors.PERMISSION_DENIED_POLICY", { current: roleLabel(t, d.currentRole) });
    if (error.code === "PERMISSION_DENIED" && typeof d.requiredRole === "string") {
      return t("errors.PERMISSION_DENIED_ROLE", { required: roleLabel(t, d.requiredRole), current: roleLabel(t, d.currentRole) });
    }
    const key = `errors.${error.code}`;
    const vars = Object.fromEntries(Object.entries(d).filter(([, v]) => typeof v === "string"));
    const msg = t(key, vars);
    return msg === key ? t("errors.generic") : msg;
  }
  return t("errors.generic");
}

export const isAuthError = (e: unknown) => e instanceof ApiError && e.status === 401;
export const errorCode = (e: unknown) => (e instanceof ApiError ? e.code : null);
